import React, { Component } from "react";
import axios from 'axios';
import api from '../api';
import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import { Container, Row, Col } from "shards-react";
import InputAdornment from '@material-ui/core/InputAdornment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import NumberFormat from 'react-number-format';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputMask from 'react-input-mask';
import Select from '@material-ui/core/Select';
import MediaFile from '../../../components/common/MediaFile'


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function TextMaskCustom(props) {
	const { inputRef, ...other } = props;
  
	return (
	  <InputMask
		{...other}
		ref={ref => {
		  inputRef(ref ? ref.inputElement : null);
		}}
		mask={[/[A-C,a,c]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
		//maskPlaceholder={'0'}
		//showMask
		alwaysShowMask={false}
		autoComplete={false}
		showMask={false}
		
	  />
	);
  }
  
const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '8px',
  	marginBottom: 0,
	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem',
  },
  tableCell:{
  	padding: '0px 6px',
  	width: '90px'
  }
});

class Voucher extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
      				snackbar:{open:false, severity: ''},
					payment_deal:0,
					payment_deal_hansa_code:'',
					provider_payment_deal: 0,
					saving: false, 
					voucher:{created_at: new Date().toISOString().slice(0, 10),tasks:[]},voucher_types:[], files:[], providers:[], budgets:[],
					voucher_types:[{}],
      				iva_conditions:{buy:[{}], sell:[{}]},
      				budgets:[],
      				providers:[],
      				files:[],
      				loading: true,
		}
  	}

    async componentDidMount() {
    	var providers = []
    	var budgets = []
		var voucher = this.state.voucher
    	providers.push(this.props.providers)
    	budgets.push(this.props.budgets)
    	var work_order_id = this.props.work_order_id
		if (providers.length >= 0){
			voucher.contact_id = providers[0].contact_id
		}

		if (budgets.length >= 0){
			voucher.budget_id = budgets[0]
		}
		


    	await this.getVouchersTaskAvalaible(work_order_id)
    	await this.getVoucherTypes()
    	await this.getDropdowns();
    	await this.getPaymentsDeals()

    	this.setState({providers: providers, budgets: budgets})
		this.setState({voucher: voucher})
    }

    getVouchersTaskAvalaible = (id) =>{
		const token = localStorage.getItem('userToken')
		axios.get(api.vouchers().tasks_available(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var voucher = this.state.voucher
	      		voucher.tasks = res.data
	      		this.setState({voucher: voucher, loading: false})
	      })
	      .catch(err =>{console.log(err)
		})    	
    }

	getVoucherTypes = () => {
		const token = localStorage.getItem('userToken')
		var voucher = this.state.voucher
		axios.get(api.voucher_types,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		var voucher_types = res.data
				if (voucher_types.length > 0 ){
					if (this.props.default_voucher_type_id){
						voucher.voucher_type_id = this.props.default_voucher_type_id
					} else {
						var voucher_type = voucher_types.filter(v => v.name === 'Factura')[0]
						voucher.voucher_type_id = (voucher_type) ? voucher_type.id : ''
					}
				}
	      		this.setState({voucher_types: voucher_types, voucher: voucher})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }

	getDropdowns = async () => {
	    let self = this
	    const token = localStorage.getItem('userToken')
	    await axios.get(api.dropdowns().ot(),
    		{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
	      		var res = response.data
	      		var iva_conditions = res.iva_conditions
	      		this.setState({iva_conditions: iva_conditions})
	      })
	      .catch(function (error) {
	    	console.log(error)
	    })
    }

    getPaymentsDeals = () => {
		const token = localStorage.getItem('userToken')
		axios.get(api.payment_deals,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({payment_deals: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })    	
    }

    handleSnackbar = (e) => {
    	e.preventDefault()
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

    handleChange = (e) => {
    	var voucher = this.state.voucher
		var payment_days_value = (this.state.payment_deal) ? this.state.payment_deal : 0

		if (e.target.name === 'voucher_date' || e.target.name === 'payment_deal'){
			if (e.target.name === 'payment_deal'){
				this.setState({payment_deal_hansa_code: e.target.value})
				var hansa_payment_deal = this.state.payment_deals.filter(p => p.hansa_code === e.target.value)[0]

				this.setState({payment_deal: hansa_payment_deal.days_value})
				payment_days_value = hansa_payment_deal.days_value
			} 
			if (e.target.name === 'voucher_date'){
				voucher.voucher_date = e.target.value
			}
			//var payment_days_value = (this.state.providers[0]) ? (this.state.providers[0].payment_deal) ? this.state.providers[0].payment_deal : 0 : 0
			var due_date = ''
			if (payment_days_value >= 0 && payment_days_value !== ''){
				due_date = new Date(voucher.voucher_date)

				if (due_date){
					due_date.setDate(due_date.getDate() + payment_days_value);
					if (!isNaN(due_date.getTime())) {
						voucher.due_date = due_date.toISOString().slice(0, 10)
					}
				}
			}
		} else {
			voucher[e.target.name] = e.target.value
		}
    	this.setState({voucher: voucher})
    }

	autcompleteNumber = (e) => {
		var voucher = this.state.voucher
		var voucher_number = voucher.number.split("-")
		if (voucher_number.length === 3){
			voucher_number[0] = voucher_number[0].toUpperCase() 
			voucher_number[1] = voucher_number[1].replaceAll("_", "")
			voucher_number[2] = voucher_number[2].replaceAll("_", "")
			if (voucher_number[1].length > 0){
				voucher_number[1] = voucher_number[1].padStart(4,"0")
			}
			if (voucher_number[2].length > 0){
				voucher_number[2] = voucher_number[2].padStart(8,"0")
			}
			voucher.number = voucher_number.join("-")
			this.setState({voucher: voucher})
			//this.getVoucherByNumber();
		}
	}

    handleTaskChange = (e) => {
    	var voucher = this.state.voucher
		var element = e.target.name.split('.')
		var key = element[0]
		var id = element[1]
		if (key ==='checked'){
			voucher.tasks[id]['checked'] = e.target.checked
		} else {
			voucher.tasks[id][key] = e.target.value.replace('$','')
		}
		this.doSubtotals();	
    }

    handleAllTasksChange = (e) => {
    	var voucher = this.state.voucher
    	voucher.all_tasks = e.target.checked
    	voucher.tasks.map((val, idx)=>{
    		voucher.tasks[idx].checked = e.target.checked
    	})
    	this.setState({voucher: voucher})
		this.doSubtotals();	
    }

	doSubtotals = () => {
		var subtotals = {materials:0, workforce:0, total:0}
	    var voucher = this.state.voucher
	    for (var i=0; i < voucher.tasks.length; i++) {
	    	if (voucher.tasks[i].checked === true){
	    		voucher.tasks[i].materials_price = (voucher.tasks[i].materials_price !== null) ? (voucher.tasks[i].materials_price) : 0
	    		voucher.tasks[i].workforce_price = (voucher.tasks[i].workforce_price !== null) ? (voucher.tasks[i].workforce_price) : 0
		    	subtotals.materials += (voucher.tasks[i].materials_price) ? +parseFloat(voucher.tasks[i].materials_price) : 0
		    	subtotals.workforce += (voucher.tasks[i].workforce_price) ? +parseFloat(voucher.tasks[i].workforce_price) : 0
		    	subtotals.total += +parseFloat(voucher.tasks[i].workforce_price) + +parseFloat(voucher.tasks[i].materials_price)
		    	voucher.tasks[i].total_price = +parseFloat(voucher.tasks[i].workforce_price) + +parseFloat(voucher.tasks[i].materials_price)
	    	}
	    }
	    voucher.subtotals = subtotals
	    this.setState({voucher: voucher})
  	}

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

    handleSubmit = (e) => {
		this.setState({saving: true})
    	e.preventDefault();
	    var formData = new FormData();
	    var voucher = this.state.voucher
	    var providers = this.state.providers
	    var i = 0;
	    if (voucher.all_tasks){
		    formData.set("voucher["+i+"][work_order_id]", this.props.work_order_id);
		    formData.set("voucher["+i+"][voucher_type_id]", voucher.voucher_type_id);
		    formData.set("voucher["+i+"][number]", (voucher.number) ? voucher.number : '');
		    formData.set("voucher["+i+"][budget_id]", (voucher.budget_id) ? voucher.budget_id : '');
		    formData.set("voucher["+i+"][contact_id]", providers[0].contact_id);
		    formData.set("voucher["+i+"][workforce_s_iva_price]", voucher.subtotals.materials);
		    formData.set("voucher["+i+"][materials_s_iva_price]", voucher.subtotals.workforce);
		    formData.set("voucher["+i+"][total_s_iva_price]", voucher.subtotals.total);
		    formData.set("voucher["+i+"][due_date]", (voucher.due_date) ? voucher.due_date : '');
		    formData.set("voucher["+i+"][reception_date]", (voucher.reception_date) ? voucher.reception_date : '');
		    formData.set("voucher["+i+"][voucher_date]", (voucher.voucher_date) ? voucher.voucher_date : '');
		    formData.set("voucher["+i+"][all_tasks]", 1);
		    formData.set("voucher["+i+"][work_order_task_id]", '');
//		    formData.set("voucher["+i+"][iva_buy_id]", (voucher.iva_buy_id) ? voucher.iva_buy_id : '');
//		    formData.set("voucher["+i+"][iva_sell_id]", (voucher.iva_sell_id) ? voucher.iva_sell_id : '');

	    } else {
		    	voucher.tasks.map((val,idx)=>{
		    	if (val.checked){
				    formData.set("voucher["+i+"][work_order_id]", this.props.work_order_id);
				    formData.set("voucher["+i+"][voucher_type_id]", voucher.voucher_type_id);
				    formData.set("voucher["+i+"][number]", (voucher.number) ? voucher.number : '');
				    formData.set("voucher["+i+"][budget_id]", (voucher.budget_id) ? voucher.budget_id : '');
				    formData.set("voucher["+i+"][contact_id]", providers[0].contact_id);
				    formData.set("voucher["+i+"][workforce_s_iva_price]", val.workforce_s_iva_price);
				    formData.set("voucher["+i+"][materials_s_iva_price]", val.materials_s_iva_price);
				    formData.set("voucher["+i+"][total_s_iva_price]", val.total_s_iva_price);
				    formData.set("voucher["+i+"][due_date]", (voucher.due_date) ? voucher.due_date : '');
				    formData.set("voucher["+i+"][reception_date]", (voucher.reception_date) ? voucher.reception_date : '');
				    formData.set("voucher["+i+"][voucher_date]", (voucher.voucher_date) ? voucher.voucher_date : '');
				    formData.set("voucher["+i+"][all_tasks]", 0);
				    formData.set("voucher["+i+"][work_order_task_id]", (val.id) ? val.id : val.work_order_task_id);
				    formData.set("voucher["+i+"][iva_buy_id]", (val.iva_buy_id) ? val.iva_buy_id : '');
					if (this.props.can_change_payment_deadline){
						if (parseInt(this.state.provider_payment_deal) !== parseInt(this.state.payment_deal) ){
							formData.set("voucher["+i+"][custom_due_date]", (voucher.due_date) ? voucher.due_date : '');
							formData.set("voucher["+i+"][custom_payment_deal]", (this.state.payment_deal_hansa_code) ? this.state.payment_deal_hansa_code : '');
						}
					}
				    //formData.set("voucher["+i+"][iva_sell_id]", (val.iva_sell_id) ? val.iva_sell_id : '');
				    i++;
		    	}
	    	})
	    }
	    i = 0;
		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.append("media["+i+"][file]", val.file[0])
					i++;
				}	
			})
		}
	    let self = this
	    const token = localStorage.getItem('userToken')
	    if (voucher.id){
		    formData.set("_method", 'PATCH');
		    formData.set("voucher[0][id]", voucher.id);
		    axios.post(api.vouchers().patch(voucher.id),
			       formData,
			       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
			       )
			      .then((response)=> {
			      		var snackbar = this.state.snackbar
			      		snackbar.open = true
			      		snackbar.severity = 'success'
			      		snackbar.success_message = 'Comprobante modificado con éxito'
				  		this.setState({snackbar:snackbar})
						this.setState({saving: false})

			      })
			      .catch(function (error) {
			      		var error_message = ''
			      		var errors = error.response.data
						if (errors.errors){
							if (errors.errors.status_code !== 404){
							  var keys = Object.keys(errors.errors); 
							  for(var i = 0; i < keys.length; i++) {   
							    var key = (keys[i]) ; 
							    var key_errors = errors.errors[key]
							    key_errors.map((val,idx)=>{
							      error_message = error_message.concat(val).concat(' ')
							    })
							  }
							} else {
								error_message = 'Ha ocurrido un error. Contacte a su administrador'
							}
						} else {
							error_message = 'Ha ocurrido un error. Contacte a su administrador'
						}
	
			      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
				  		self.setState({ snackbar: snackbar})
						self.setState({saving: false})

			    })

	    } else {
		    axios.post(api.vouchers().post(),
		       formData,
		       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		       )
		      .then((response)=> {
		      		var snackbar = this.state.snackbar
		      		snackbar.open = true
		      		snackbar.severity = 'success'
		      		snackbar.success_message = 'Comprobante cargado con éxito'
			  		this.setState({snackbar:snackbar})
					this.setState({saving: false})
					this.props.created(e, this.props.id)
		      })
		      .catch(function (error) {
		      		var error_message = ''
		      		var errors = error.response.data
					if (errors.errors){
						if (errors.errors.status_code !== 404){
						  var keys = Object.keys(errors.errors); 
						  for(var i = 0; i < keys.length; i++) {   
						    var key = (keys[i]) ; 
						    var key_errors = errors.errors[key]
						    key_errors.map((val,idx)=>{
						      error_message = error_message.concat(val).concat(' ')
						    })
						  }
						} else {
							error_message = 'Ha ocurrido un error. Contacte a su administrador'
						}
					} else {
						error_message = 'Ha ocurrido un error. Contacte a su administrador'
					}

		      		var snackbar = {open: true, success_message: error_message, severity: 'warning'}
			  		self.setState({ snackbar: snackbar})
					self.setState({saving: false})

		    })

	    }

    }

  	render(){
		const classes = this.props.classes;
		var payment_deal = (this.state.payment_deal) ? this.state.payment_deal : 0 
		const iva_conditions = this.state.iva_conditions

  		return (
	  			<React.Fragment>
	  			{(this.state.loading !== true)
	  				?
					<div className="row col-12 mt-2 ml-2">
						<div className="">
						<Snackbar open={this.state.snackbar.open} onClose={this.handleSnackbar}>
							<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
							  {this.state.snackbar.success_message}
							</Alert>
						</Snackbar>
						{/*<TextField
							id="number"
							value={this.state.voucher.number}
							onChange={this.handleChange}
							type="text"
							required
							name="number"
							margin="normal"
							className="m-0 p-0 mr-2 mt-2"
							InputLabelProps={{
								shrink: true
							}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>Nro factura</Typography></InputAdornment>,
							}}
							inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
						/>*/}
						<Input
							id="number"
							name="number"
							label="Nro factura"
							value={this.state.voucher.number}
							disabled={(this.state.voucher.id > 0) ? true : false }
							onChange={this.handleChange}
							placeholder="Ingrese nro factura"
							margin="normal"
							className="m-0 p-0 mr-2 mt-2"
							inputProps={{style:{minWidth: 100, fontSize: '0.75rem'}}} 
							inputComponent={TextMaskCustom}
							startAdornment={<Typography variant="caption" style={{width: 100}}>Nro factura</Typography>}
							onBlur={this.autcompleteNumber}
						/>


				       <TextField
							id="voucher_type_id"
							name="voucher_type_id"
							select
							margin="normal"
							className={classes.select}
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={this.state.voucher_type_id}
							inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Tipo de Comprobante</Typography></InputAdornment>,
					            style:{fontSize: '0.75rem'}
								}}
				        >
				          {this.state.voucher_types.map((option) => (
				            <MenuItem key={option.id} value={option.id} className={classes.typography}>
				              {option.name}
				            </MenuItem>
				          ))}
				        </TextField>

				       {/*<TextField
							id="contact_id"
							name="contact_id"
							select
							margin="normal"
							className={classes.select}
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={this.state.voucher.contact_id}
							inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 100}}>Proveedor</Typography></InputAdornment>,
					            style:{fontSize: '0.75rem'}
								}}
				        >
				          {this.state.providers.map((option) => (
				            <MenuItem key={option.id} value={option.id} className={classes.typography}>
				              {option.business_name}
				            </MenuItem>
				          ))}
				        </TextField>*/}

				       {/*<TextField
							id="budget_id"
							name="budget_id"
							select
							margin="normal"
							className={classes.select}
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={this.state.voucher.budget_id}
							inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Presupuesto</Typography></InputAdornment>,
					            style:{fontSize: '0.75rem'}
								}}
				        >
				          {this.state.budgets.map((option) => (
				            <MenuItem key={option} value={option} className={classes.typography}>
				              {option}
				            </MenuItem>
				          ))}
						  </TextField>*/}
				    </div>
				    <div>
						<TextField
							id="reception_date"
							value={this.state.voucher.reception_date}
							onChange={this.handleChange}
							type="date"
							required
							name="reception_date"
							margin="normal"
							className="m-0 p-0 mr-2 mt-2"
							InputLabelProps={{
								shrink: true
							}}
				          	InputProps={{
					            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de recepción</Typography></InputAdornment>,
							}}
							inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
						/>
								<TextField
									id="voucher_date"
									value={this.state.voucher.voucher_date}
									onChange={this.handleChange}
									type="date"
									required
									name="voucher_date"
									margin="normal"
									className="m-0 p-0 mr-2 mt-2"
									InputLabelProps={{
										shrink: true
									}}
						          	InputProps={{
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de factura</Typography></InputAdornment>,
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
								<TextField
									id="created_at"
									value={this.state.voucher.created_at}
									onChange={this.handleChange}
									type="date"
									required
									name="created_at"
									margin="normal"
									className="m-0 p-0 mr-2 mt-2"
									InputLabelProps={{
										shrink: true
									}}
						          	InputProps={{
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 120}}>Fecha de carga</Typography></InputAdornment>,
									}}
									inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}}
								/>
								{(!this.props.can_change_payment_deadline)
								?
									<TextField
										id="payment_deal"
										name="payment_deal"
										margin="normal"
										disabled
										type="text"
										className={classes.select}
										InputLabelProps={{
											shrink: true
										}}
										value={payment_deal}
										inputProps={{style:{fontSize: '0.75rem'}}}
										InputProps={{
											startAdornment: <InputAdornment position="start" ><Typography variant="caption">Termino de pago</Typography></InputAdornment>,
											style:{fontSize: '0.75rem'}
										}}
									/>
								:
									<TextField
										id="payment_deal"
										name="payment_deal"
										margin="normal"
										select
										type="text"
										className={classes.select}
										InputLabelProps={{
											shrink: true
										}}
										disabled={(this.state.voucher.id > 0) ? true : false }
										onChange={this.handleChange}
										value={(this.state.payment_deal_hansa_code) ? this.state.payment_deal_hansa_code : ''}
										inputProps={{style:{fontSize: '0.75rem'}}}
										InputProps={{
											startAdornment: <InputAdornment position="start" ><Typography variant="caption">Termino de pago</Typography></InputAdornment>,
											style:{fontSize: '0.75rem'}
										}}
										>
										{this.state.payment_deals.map((option) => {
											if (!option.is_visible_in_vouchers)
												return;
											return (
												<MenuItem key={option.id} value={option.hansa_code} className={classes.typography}>
													{option.hansa_code} - {option.name} - {option.days_value}
												</MenuItem>
											)
										})}
									</TextField>

								}
						        <TextField
									id="payment_deal"
									name="payment_deal"
									margin="normal"
									disabled
									type="date"
									className={classes.select}
									InputLabelProps={{
										shrink: true
									}}
								    value={this.state.voucher.due_date}
									inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
						          	InputProps={{
							            startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha de vencimiento</Typography></InputAdornment>,
							            style:{fontSize: '0.75rem'}
										}}
						        />

						<div class="row mt-2">
							<Table size="medium" aria-label="a dense table" style={{width: 'auto', minWidth:'100%'}}>
					    	    <TableHead>
									<TableRow>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >
													{/*<Checkbox
														name="all_tasks"
														value={this.state.voucher.all_tasks}
														onChange={this.handleAllTasksChange}
													/>*/}
													&nbsp;
							            </TableCell>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Tarea</TableCell>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Mano de obra s/iva</TableCell>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Materiales s/iva</TableCell>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >Total s/iva</TableCell>
							            <TableCell className={classes.tableCell} style={{fontWeight: '550'}} >IVA Compras</TableCell>
							            {/*<TableCell className={classes.tableCell} style={{fontWeight: '550'}} >IVA Ventas</TableCell>*/}
									</TableRow>
								</TableHead>
								<TableBody>
								{this.state.voucher.tasks.map((val, idx)=>{
									return (
										<React.Fragment>
										<TableRow>
											<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
												{(this.state.voucher.all_tasks)
													?
														''
													:
														<Checkbox
															name={"checked."+idx}
															id={"checked."+idx}
															checked={val.checked}
															onChange={this.handleTaskChange}																
														/>
												}

											</TableCell>													
											<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
												{val.task.name}
											</TableCell>	
											<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
												<NumberFormat 
													id={"workforce_s_iva_price."+idx}
													name={"workforce_s_iva_price."+idx}
													value={val.workforce_s_iva_price}
													onChange={this.handleTaskChange}
													className="m-0 p-0"
												    InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
												    decimalSeparator='.'
												    prefix={'$'}
												    customInput={TextField}  
												    InputLabelProps={{
												      shrink: true,
												    }}
												    isAllowed={(values) => {
										              let { floatValue } = values;
										              floatValue = (floatValue !== undefined) ? floatValue : 0
												      return floatValue >= 0 && floatValue < 99999999;
												    }}            

													/>								          
											</TableCell>	
											<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
												<NumberFormat 
													id={"materials_s_iva_price."+idx}
													name={"materials_s_iva_price."+idx}
													value={val.materials_s_iva_price}
													onChange={this.handleTaskChange}
													className="m-0 p-0"
												    InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
												    decimalSeparator='.'
												    prefix={'$'}
												    customInput={TextField}  
												    InputLabelProps={{
												      shrink: true,
												    }}
												    isAllowed={(values) => {
										              let { floatValue } = values;
										              floatValue = (floatValue !== undefined) ? floatValue : 0
												      return floatValue >= 0 && floatValue < 99999999;
												    }}            

													/>								          
											</TableCell>	
											<TableCell className={classes.tableCell} style={{fontSize: '0.75rem'}} >
												<NumberFormat 
													id={"total_s_iva_price."+idx}
													name={"total_s_iva_price."+idx}
													value={val.total_s_iva_price}
													onChange={this.handleTaskChange}
													className="m-0 p-0"
												    InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
												    decimalSeparator='.'
												    prefix={'$'}
												    customInput={TextField}  
												    InputLabelProps={{
												      shrink: true,
												    }}
												    isAllowed={(values) => {
										              let { floatValue } = values;
										              floatValue = (floatValue !== undefined) ? floatValue : 0
												      return floatValue >= 0 && floatValue < 99999999;
												    }}            

													/>								          
											</TableCell>
								            <TableCell className={classes.tableCell}>
										        <Select native name={"iva_buy_id."+idx}
										            inputProps={{
										              name:"iva_buy_id."+idx,
										              className:"iva_buy_id."+idx
										            }}
										            value={val.iva_buy_id}
										            style={{fontSize: '0.75rem', width: 70}}
										            onChange={this.handleTaskChange}
										            required
										            input={<Input id="grouped-native-select" name='contract_id'/>}>
										            <option value="" />
										            {iva_conditions.buy.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
										          </option>)}
										        </Select>
								            </TableCell>
								            {/*<TableCell className={classes.tableCell}>
										        <Select native name={"iva_sell_id."+idx}
										            inputProps={{
										              name:"iva_sell_id."+idx,
										              className:"iva_sell_id."+idx
										            }}
										            value={val.iva_sell_id}
										            style={{fontSize: '0.75rem', width: 70}}
										            onChange={this.handleTaskChange}
										            required
										            input={<Input id="grouped-native-select" name='contract_id'/>}>
										            <option value="" />
										            {iva_conditions.sell.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
										          </option>)}
										        </Select>
								            </TableCell>*/}
											</TableRow>	
										</React.Fragment>
									)
								})}
								</TableBody>
							</Table>
						</div>
					</div>
					<div className="row col-12 mt-2">
						<MediaFile onChange={this.handleUploadFile} title="Agregar comprobante" width={"15rem"} height={"2rem"}  meta_data="comprobante" />
						<Button variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>Guardar</Button>
					</div>
				</div>
				:
					''
	  			}
			</React.Fragment>
		)
  	}
}

export default withStyles(useStyles)(Voucher);
